import React, { useState, useEffect, useRef } from "react"
import { ValidationError, useForm } from "@formspree/react"
import axios from "axios"
import scrollTo from "gatsby-plugin-smoothscroll"
import * as helpers from "../../helpers/sectionclasses"
import { useStaticQuery, graphql, Link } from "gatsby"
import { TransitionPortal } from "gatsby-plugin-transition-link";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import InView from "react-intersection-observer"
import { motion, AnimatePresence } from "framer-motion"
import ContactArrow from "../../images/arrow-contact.svg"
import VideoThumb1 from "../../images/video-thumb-placeholder-1.jpg"
import VideoThumb2 from "../../images/video-thumb-placeholder-2.jpg"
import VimeoPlyrEmbed from "../vimeoplyrembed"

const ContactForm2022 = ({ content }) => {

  const { wp } = useStaticQuery(
    graphql`
      query {
        wp {
          globalOptions {
            globalSiteOptions {
              googleMapLink
              email
              phoneNumber
              socialHandles {
                link
                title
              }
            }
          }
        }
      }
    `
  )

  const sectionClasses = helpers.sectionClasses(content.sectionOptions)
  const [showForm, setShowForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [page1Completion, setPage1Completion] = useState(false);
  const [page2Completion, setPage2Completion] = useState(false);
  const [page3Completion, setPage3Completion] = useState(false);
  // const [page4Completion, setPage4Completion] = useState(false);


  const maxPages = 3;

  const formModalMain = useRef(null);

  const [checkboxValues1, setCheckboxValues1] = useState([]);
  const [checkboxValues2, setCheckboxValues2] = useState([]);

  const [submissionClick, setSubmissionClick] = useState(false);
  const [generalErrorMessage, setGeneralErrorMessage] = useState(false);
  const [initialInfoSent, setInitialInfoSent] = useState(false);

  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoModalInfo, setVideoModalInfo] = useState({
    title: '',
    subtitle: '',
    desc: '',
    iframe: '',
    placeholder: ''
  })

  const videoModal = (e) => {
    const title = e.target.dataset.title;
    const subtitle = e.target.dataset.subtitle;
    const desc = e.target.dataset.desc;
    const iframe = e.target.dataset.iframe;
    const placeholder = e.target.dataset.placeholder;
    setVideoModalInfo({
      title: title,
      subtitle: subtitle,
      desc: desc,
      iframe: iframe,
      placeholder: placeholder
    })
    setShowVideoModal(true);
  }

  const dropIn = {
    hidden: {
      y: "100vh",
      opacity: 1,
      transition: {
        duration: 0.4,
        type: "linear",
        damping: 25,
        stiffness: 500,
      },
    },
    visible: {
      y: "0",
      opacity: 1,
      transition: {
        duration: 0.4,
        type: "linear",
        damping: 25,
        stiffness: 500,
      },
    },
    exit: {
      y: "100vh",
      opacity: 1,
      transition: {
        duration: 0.4,
        type: "linear",
        damping: 25,
        stiffness: 500,
      },
    },
  };

  const [totalPrice, setTotalPrice] = useState('');

  const priceList1 = [
    {name: 'Innovate', price: 5000},
    {name: 'Trust', price: 3000},
    {name: 'Recap', price: 2200},
    {name: 'Hype', price: 4500},
    {name: 'Trend', price: 5500},
    {name: 'Monthly', price: 950}
  ]

  const priceList2 = [
    {name: 'Social Formats', price: 75},
    {name: 'Shorter Social Edits', price: 250},
    {name: 'Drone Filming', price: 750},
    {name: 'Photography', price: 400},
    {name: 'Fast-Track Production', price: 800},
    {name: 'Behind The Scenes', price: 1200}
  ]

  const updatePrice = () => {
    // let price = (checkboxValues1.length * 3000) + (checkboxValues2.length * 3000);
    let price = 0;
    checkboxValues1.forEach((itemName) => {
      const itemPrice = priceList1.find(item => item.name === itemName).price;
      if(itemPrice) {
        price = price + itemPrice;
      }
    });

    checkboxValues2.forEach((itemName) => {
      const itemPrice = priceList2.find(item => item.name === itemName).price;
      if(itemPrice) {
        price = price + itemPrice;
      }
    });

    if(price !== null && price !== undefined) {
      price = `£${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
      setTotalPrice(price);
      setInputs(prev => ({
        ...prev,
        'price': price,
      }))
    }
  }

  const findPrice = (itemName, priceList) => {
    let price = 0;
    const itemPrice = priceList.find(item => item.name === itemName).price;
    if(itemPrice) {
      price = price + itemPrice;
      price = `£${price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;

      return (
        price
      );
    } else {
      return '';
    }
  }

  
  const openModal = (e) => {
    e.preventDefault();
    setShowForm(true);
    document.body.classList.add("no-scroll")
  }

  const closeModal = () => {
    setShowForm(false);
    document.body.classList.remove("no-scroll")
  }

  const closeModalAndReset = () => {
    setShowForm(false);
    setCurrentPage(1);
    document.body.classList.remove("no-scroll");
    setCheckboxValues1([]);
    setCheckboxValues2([]);
    setSubmissionClick(false);
    setGeneralErrorMessage(false);
    setTotalPrice('');
    setInputs({
      email: "",
      name: "",
      packages: "",
      extras: "",
      //company: "",
     // phone: "",
     // budget: "",
      //additionalInfo: "",
      price: ""
    });
    setServerState({
      submitting: false,
      status: null,
    })
  }

  const handleCheck = (e) => {
    const checkboxID = e.target.id;
    const parent = document.querySelector(`.form-checkbox[data-checkbox="${checkboxID}"]`);
    if(parent) {
      if(parent.classList.contains('checked')) {
        parent.classList.remove('checked');
      } else {
        parent.classList.add('checked');
      }
    } 
  }

  const nextPage = () => {
    if (!validateSinglePage(currentPage)) {
      return
    }
    if(currentPage == 1 && initialInfoSent == false) {
      axios({
      method: "POST",
      url: "https://formspree.io/myybrqav",
      data: inputs,
      })
      .then(r => {
       setInitialInfoSent(true);
      })
      .catch(r => {
        console.log('error with submission: '+r.response.data.error);
      })
    } 

    if(currentPage == 1 && page1Completion == false) {
      setPage1Completion(true);
    }
    if(currentPage == 2 && page2Completion == false) {
      setPage2Completion(true);
    }
    if(currentPage == 3 && page3Completion == false) {
      setPage3Completion(true);
    }

    // if(currentPage == 4 && page4Completion == false) {
    //   setPage4Completion(true);
    // }

    setCurrentPage(currentPage+1);

  };

  const [dropdown, setDropdown] = useState('');
  const dropdownToggle = (dropdownEl) => {
    if(dropdownEl !== dropdown) {
      setDropdown(dropdownEl)
    } else {
      setDropdown('');
    }
  }

  const [fieldErrors, setFieldErrors] = useState({})
  const validationRules = {
    email: val => val && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
    name: val => !!val,
    //company: val => !!val,
    //phone: val => !val || !!val, // Modified: Phone field is optional
    // budget: val => !val || !!val, // Modified: Budget field is optional
    packages: val => !!val,
    extras: val => !val || !!val, // Modified: Extras field is optional
    // additionalInfo: val => !!val,
    price: val => !val || !!val, // Modified: Extras field is optional
  }
  // Specify fields on a page-by-page basis for splitting validation on each step
  const page1 = ['name', 'email'];
  const page2 = ['packages'];
  const page3 = ['extras'];
  //const page4 = ['company', 'budget', 'phone', 'additionalInfo'];

  const validateSinglePage = (page) => {
    let errors = {}
    let hasErrors = false;
    let pageToCheck;
    if(page == 1) {pageToCheck = page1}
    if(page == 2) {pageToCheck = page2}
    if(page == 3) {pageToCheck = page3}
    pageToCheck.forEach(key => {
      errors[key] = !validationRules[key](inputs[key])
      hasErrors |= errors[key]
    });
    setFieldErrors(prev => ({ ...prev, ...errors }))
    return !hasErrors
  }

  const validate = () => {
    let errors = {}
    let hasErrors = false
    for (let key of Object.keys(inputs)) {
      errors[key] = !validationRules[key](inputs[key])
      hasErrors |= errors[key]
    }
    setFieldErrors(prev => ({ ...prev, ...errors }))
    return !hasErrors
  }
  const renderFieldError = field => {
    if (fieldErrors[field]) {
      return (
        <div className="w-full flex justify-end pt-4 pb-2">
          <p className="errorMsg text-red">Please enter valid {field}.</p>
        </div>
      )
    }
  }

  // Input Change Handling
  const [inputs, setInputs] = useState({
    email: "",
    name: "",
    packages: "",
    extras: "",
    // company: "",
    // phone: "",
    // budget: "",
    // additionalInfo: "",
    price: "",
  });

  useEffect(() => {
    if(page1Completion == true) {
      typeof window !== "undefined" &&
        window.dataLayer.push({'event': 'quote_form_name_email_complete'});
    }
  }, [page1Completion]);

  useEffect(() => {
    if(page2Completion == true) {
      typeof window !== "undefined" &&
        window.dataLayer.push({'event': 'quote_form_packages_complete'});
    }
  }, [page2Completion]);

  useEffect(() => {
    if(page3Completion == true) {
      typeof window !== "undefined" &&
        //window.dataLayer.push({'event': 'quote_form_extras_complete'});
        window.dataLayer.push({'event': 'quote_form_submitted'});
    }
  }, [page3Completion]);

  // useEffect(() => {
  //   if(page4Completion == true) {
  //     typeof window !== "undefined" &&
  //       window.dataLayer.push({'event': 'quote_form_submitted'});
  //   }
  // }, [page4Completion]);

  useEffect(() => {

    for(const [key, value] of Object.entries(inputs)) {
        const field = document.getElementById(key);
        if( value.length > 0 && field ) {
          field.classList.add('filled');
        }
    }
    if(formModalMain.current) {
      formModalMain.current.scrollTop = 0;
    }
  }, [currentPage, showForm])

  useEffect(() => {
    const checkedValues = checkboxValues1.join(', ');
    setInputs(prev => ({
      ...prev,
      'packages': checkedValues,
    }))
    updatePrice();
  }, [checkboxValues1]);

  useEffect(() => {
    const checkedValues = checkboxValues2.join(', ');
    setInputs(prev => ({
      ...prev,
      'extras': checkedValues,
    }))
    updatePrice();
  }, [checkboxValues2]);

  // useEffect(() => {
  //   // Only perform interactive validation after submit
  //   if (Object.keys(fieldErrors).length > 0) {
  //     validate()
  //   }
  // }, [inputs])
  /* End new validation ^^^^ */

  const test = () => {
    setServerState({ submitting: false, status: { ok: 400, msg: "Sorry, it doesn‘t look like this form submitted successfully, please contact us to follow up on your quote." }, })
  }

  useEffect(() => {
    if(submissionClick == true) {
      handleOnSubmit();
    }
  }, [submissionClick]);

  useEffect(() => {
    for(const [key, value] of Object.entries(fieldErrors)) {
      if(value == true) {
        setGeneralErrorMessage(true)
      } else {
        setGeneralErrorMessage(false)
      }
    }
  }, [fieldErrors])

  const handleOnChange = event => {
    event.persist()

    if( event.target.value.length > 0 ) {
      event.target.classList.add('filled');
    } else {
      event.target.classList.remove('filled');
    }
    if(event.target.type !== 'checkbox') {
      setInputs(prev => ({
        ...prev,
        [event.target.id]: event.target.value,
      }))
    } else {

      // Update the checkedValues state based on the checkbox change
      if (event.target.checked) {
        if(event.target.name == 'packages') {
          setCheckboxValues1((prevCheckedValues) => [...prevCheckedValues, event.target.value]);
        } else {
          setCheckboxValues2((prevCheckedValues) => [...prevCheckedValues, event.target.value]);
        }
       
      } else {
       
        if(event.target.name == 'packages') {
          setCheckboxValues1((prevCheckedValues) =>
            prevCheckedValues.filter((val) => val !== event.target.value)
          );
        } else {
          setCheckboxValues2((prevCheckedValues) =>
            prevCheckedValues.filter((val) => val !== event.target.value)
          );
        }
      }


    }
  }

  // Server State Handling
  const [serverState, setServerState] = useState({
    submitting: false,
    status: null,
  })
  const handleServerResponse = (ok, msg) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    })
    if (ok) {
      setFieldErrors({})
      setInputs({
        name: "",
        email: "",
        packages: "",
        extras: "",
        company: "",
        phone: "",
        budget: "",
        additionalInfo: "",
        price: ""
      })

      typeof window !== "undefined" &&
        window.gtag("event", "quote_conversion", {
          send_to: "AW-307981087/PLeECPblyfUCEJ_W7ZIB",
      })

    }
  }

  const handleOnSubmit = event => {
    
    if(event) {
      event.preventDefault()
    }

    if (!validate()) {
      return
    }

    setServerState({ submitting: true })

    axios({
      method: "POST",
      url: "https://formspree.io/myybrqav",
      data: inputs,
    })
      .then(r => {
        handleServerResponse(true, "Thanks! We’ll be in touch shortly!");
        setCurrentPage(currentPage + 1);
        updatePrice();
      })
      .catch(r => {
        handleServerResponse(false, 'Sorry, it doesn‘t look like this form submitted successfully, please contact us to follow up on your quote.');
        console.log('error with submission: '+r.response.data.error);
      })
    
  }

  return (
    <>
    <section
      id="form"
      className={`${
        serverState.status && serverState.status.ok ? "relative " : ""
      }${sectionClasses} contactnew`}
    >
      
      <div className="container">

        
            
        <div className="tab:w-8/12 lrg:px-6">
    
            <p>Contact us</p>
        
            <div className="contactnew__title">
                <h1 className="text-base lrg:text-xlalt mb-10">
                    Let’s Make Movies
                </h1>
                <p>You’ve got two options; 01. See our prices and build your quote right here, immediately or 02. send us a ready-made brief for your bespoke production.</p>
            </div>
            
        </div>

        <div className="lrg:px-6 tab:flex justify-between">

            <div className="w-full">
              <ul className="contactnew__options text-md sml:text-mobmd note:text-lg w-full">
                  <li className="w-full">
                    <a href="#" onClick={ openModal } className="inline-flex items-center w-full justify-between">
                      <p><i>01.</i>See our Prices</p>
                      <span><img src={ContactArrow} alt="click to see our prices" /></span>
                    </a>
                  </li>
                  <li className="w-full">
                    <a href="mailto:talk@standbyproductions.co.uk" className="inline-flex items-center w-full justify-between">
                      <p><i>02.</i>Send a Brief</p>
                      <span><img src={ContactArrow} alt="click to send a brief" /></span>
                    </a>
                  </li>
                  
              </ul>

              
              <div className="contactnew__contact-details hidden tab:block">

                <p>
                  <a
                    href={`tel: ${wp.globalOptions.globalSiteOptions?.phoneNumber}`}
                  >
                    {wp.globalOptions.globalSiteOptions?.phoneNumber}
                  </a>
                
                  <a href={`mailto: ${wp.globalOptions.globalSiteOptions?.email}`}>
                  {wp.globalOptions.globalSiteOptions?.email}
                  </a>
                </p>
                <p>
                  Standby Productions Studio 3G, Beehive Mill Jersey St,
                  Ancoats, Manchester M4 6JG
                </p>

              </div>
            </div>

            <div className="image w-full tab:w-5/12 desk:w-6/12">
              
            {content.image?.localFile?.childImageSharp && (
                <InView threshold={0} triggerOnce={true}>
                {({ ref, inView }) => (
                    <motion.div
                    ref={ref}
                    initial={{ opacity: 0, y: 35 }}
                    animate={
                        inView
                        ? { opacity: 1, y: 0 }
                        : { opacity: 0, y: 35 }
                    }
                    transition={{ duration: 0.8 }}
                    >
                    <GatsbyImage 
                        image={getImage(content.image.localFile.childImageSharp)} 
                        className="w-full" 
                        alt={content.image.altText} 
                        loading="eager"
                        layout="fullWidth"
                    />

                    </motion.div>
                )}
                </InView>
            )}
            </div>

            <div className="contactnew__contact-details block tab:hidden">

                <p>
                  <a
                    href={`tel: ${wp.globalOptions.globalSiteOptions?.phoneNumber}`}
                  >
                    {wp.globalOptions.globalSiteOptions?.phoneNumber}
                  </a>
                
                  <a href={`mailto: ${wp.globalOptions.globalSiteOptions?.email}`}>
                  {wp.globalOptions.globalSiteOptions?.email}
                  </a>
                </p>
                <p>
                  Standby Productions Studio 3G, Beehive Mill Jersey St,
                  Ancoats, Manchester M4 6JG
                </p>

              
            </div>

        </div>

      </div>

    </section>

    <TransitionPortal level="top">
      <AnimatePresence mode="wait">
      {showVideoModal &&
        <motion.div
            onClick={(e) => e.stopPropagation()}  
            className={`video-modal text-white`}
            variants={dropIn}
            initial="hidden"
            animate="visible"
            exit="exit"
          >


            <div className="inner container">

              <div className="closer" onClick={ ()=> setShowVideoModal(false)}>
                Close
              </div>

              <div className="left">
                <VimeoPlyrEmbed
                  autoPlay={true}
                  label=''
                  title=''
                  textAlign=''
                  source={videoModalInfo.iframe}
                  posterImg={videoModalInfo.placeholder}
                  reverseLabelOrder=''
                />

              </div>

              <div className="right">

                  <p className="title mb-2">{videoModalInfo.title}</p>
                  <p className="mb-5 opacity-50">{videoModalInfo.subtitle}</p>
                  <p>{videoModalInfo.desc}</p>

              </div>

            </div>

          </motion.div>
      }
      </AnimatePresence>
      </TransitionPortal>
    
      <TransitionPortal>
      <AnimatePresence mode="wait">
      {showForm &&
        <motion.div
            onClick={(e) => e.stopPropagation()}  
            className={`form-modal form-modal--${currentPage} text-white`}
            variants={dropIn}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
          {(generalErrorMessage == true  && currentPage !== 4)
          ?
            <p className='text-red error-general container top-4 absolute'>Please make sure all fields are filled correctly</p>
          :
            ''
          }

          {(serverState.status?.msg && currentPage !== 4)
          ?  <p className='text-red error-general container top-4 absolute'>{serverState.status?.msg}</p>
          : ""
          }

          {serverState.submitting == true
          ?  <p className='text-white error-general container top-4 absolute'>Submitting</p>
          : ""
          }

          {currentPage < 4 && 
            <form 
              className="container"
              onSubmit={handleOnSubmit}
              noValidate
            >
            
              <p>See our Prices</p>
                         
              <div className={`form-modal__main form-modal__main${currentPage}`} ref={formModalMain}>
                <div className="form-modal__intro">
                      {currentPage == 1 &&
                        <>
                        <h2 className="text-base lrg:text-lg">Let’s get your quote started</h2>
                        <p>We need some basic details and then we’re off. No more back and forth on budgets, no more smoke and mirrors. This is video content with ease, no faff.</p>
                        </>
                      }
                      {currentPage == 2 &&
                        <>
                        <h2 className="text-base lrg:text-lg">See our production packages below and choose which one is right for you</h2>
                        <p>See example films and what’s included in each package. If the these aren’t quite right for you, send us a brief with what you’re after <a href="mailto:enquiries@standbyproductions.co.uk">here</a></p>
                        </>
                      }
                      {currentPage == 3 &&
                        <>
                        <h2 className="text-base lrg:text-lg">Suggested extras</h2>
                        <p>Need something a little extra, select one or multiple options here</p>
                        </>
                      }
                      {/* {currentPage == 4 &&
                        <>
                        <h2 className="text-base lrg:text-lg">Tell us a bit more</h2>
                        <p>One final step is to give us a bit more information about your project and you’ll get your quote on the next page - no commitment. No more waiting for proposals and budgets. Let’s make an impact together with some cracking video content. </p>
                        </>
                      } */}
                </div>

                {currentPage == 1 &&
                <div className="form-modal__page form-modal__page1">
                    <div className="form-row text-black tab:flex w-100 justify-between">
                      
                      <div className="form-field col-half relative">
                          <input
                            value={inputs.name}
                            name="name"
                            id="name"
                            type="text"
                            placeholder=""
                            onChange={(e) => handleOnChange(e)}
                          />
                          <label htmlFor="name" className="input-label">Your Name</label>
                          {renderFieldError('name')}
                      </div>

                      <div className="form-field col-half relative">
                          <input
                            value={inputs.email}
                            name="email"
                            id="email"
                            type="email"
                            placeholder=""
                            onChange={(e) => handleOnChange(e)}
                          />
                          <label htmlFor="email" className="input-label">Your Email</label>
                          {renderFieldError('email')}
                      </div>
                        

                    </div>
                </div>
                }

                {currentPage == 2 &&
                  <div className="form-modal__page form-modal__page2">
                    {renderFieldError('packages')}
                    <fieldset className="form-checkboxes form-checkboxes--full">
                      <div className={`form-checkbox ${checkboxValues1.includes("Innovate") ? 'checked' : ''}`} data-checkbox="packages0">
                          <div className="checkbox-head flex flex-wrap tab:flex-nowrap">
                              <div className="left">
                                <h3 className="text-mobmd tab:text-md">Innovate <span onClick={(e) => dropdownToggle('packages0')}><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"> <g id="Group_241" data-name="Group 241" transform="translate(-381 -667)"> <g id="Path_10" data-name="Path 10" transform="translate(381 667)" fill="none"> <path d="M7.5,0A7.5,7.5,0,1,1,0,7.5,7.5,7.5,0,0,1,7.5,0Z" stroke="none"/> <path d="M 7.5 1 C 3.915889739990234 1 1 3.915889739990234 1 7.5 C 1 11.08411026000977 3.915889739990234 14 7.5 14 C 11.08411026000977 14 14 11.08411026000977 14 7.5 C 14 3.915889739990234 11.08411026000977 1 7.5 1 M 7.5 0 C 11.64213943481445 0 15 3.35785961151123 15 7.5 C 15 11.64213943481445 11.64213943481445 15 7.5 15 C 3.35785961151123 15 0 11.64213943481445 0 7.5 C 0 3.35785961151123 3.35785961151123 0 7.5 0 Z" stroke="none" fill="#fff"/> </g> <path id="Path_20" data-name="Path 20" d="M1.19,4.19a.581.581,0,1,0,0-1.16.581.581,0,1,0,0,1.16ZM1.63,10V5.33H.76V10Z" transform="translate(387.305 667.986)" fill="#fff"/> </g> </svg></span></h3>
                                <p className="text-base opacity-50">Corporate Video</p>
                              </div>
                              <div className="middle">
                                <div className="inner">
                                  <p>Not your average 'Corporate Video' that's for sure. As we've done for over 10 years, we push the boundaries and take things to a whole new level to make your business have impact and showcase it in the best light possible. This should be your flagship piece of marketing collateral and our Innovate solution is perfect for creating just that!</p>
                                  <span onClick={(e) => dropdownToggle('packages0')}>Find out more</span>
                                </div>
                              </div>
                              <div className="right flex">
                                <div className="price">
                                  <p className="text-mobmd tab:text-md"><span className="text-base opacity-50">From</span> £5,000</p>
                                </div>
                                <div className="checkbox">
                                    <label htmlFor="packages0" className="sr-only">Innovate</label>
                                    <input type="checkbox" defaultChecked={checkboxValues1.includes("Innovate") ? true : false} onChange={handleOnChange} name="packages" onClick={handleCheck} id="packages0" value="Innovate" />
                                </div>
                              </div>
                          </div>
                          <AnimatePresence initial={false}>
                            {dropdown == 'packages0' && (
                            <motion.div
                              initial="collapsed"
                              animate="open"
                              exit="collapsed"
                              variants={{
                                open: { opacity: 1, height: "auto" },
                                collapsed: { opacity: 0, height: 0 }
                              }}
                              transition={{ duration: 0.8 }}
                              className="overflow-hidden"
                            >
                              <div className="checkbox-content">
                                <div className="checkbox-content__inner">
                                    <h4>What’s included?</h4>
                                    <ul>
                                      <li>Creative Development & Project Management</li>
                                      <li>Pre-Production</li>
                                      <li>1 Day Shoot - Producer & Camera Op</li>
                                      <li>4x Edit Days </li>
                                      <li>Library Music Track</li>
                                      <li>Asset Delivery</li>
                                    </ul>
                                    <h4>Example Films</h4>
                                    <div className="video-grid">
                                        <img 
                                          onClick={videoModal}
                                          src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/06/talisker-preview-768x432.jpg" 
                                          data-iframe="https://player.vimeo.com/progressive_redirect/playback/198969237/rendition/1080p/file.mp4?loc=external&log_user=0&signature=246fc7749f19703f8212846f5a11274d0ca0e3d2f7d217ac5fc0264c5a2d3309"
                                          data-title="Taziker" 
                                          data-subtitle="Company Film"
                                          data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/06/talisker-preview.jpg"
                                          data-desc="Taziker Industrial got in contact with STANDBY PRODUCTIONS looking for a film that could showcase their expertise in the steel structure repair and restoration sector. They needed a film that matched their industry leading standards and next generation thinking – we knew we could deliver." 
                                        />
                                        <img 
                                          onClick={videoModal}
                                          src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/sharp-gaming-preview-768x432.jpeg" 
                                          data-iframe="https://player.vimeo.com/progressive_redirect/playback/776970087/rendition/1080p/file.mp4?loc=external&log_user=0&signature=0c1f3f2fed90aca6a6e360292fcdbcf616825957dc614944cfe9782f6c004560"
                                          data-title="Sharp Gaming"
                                          data-subtitle="About Us"
                                          data-desc=""
                                          data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/sharp-gaming-preview.jpeg"
                                        />
                                        <img 
                                          onClick={videoModal}
                                          src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/pls-preview-768x432.jpg"
                                          data-iframe="https://player.vimeo.com/progressive_redirect/playback/776976049/rendition/1080p/file.mp4?loc=external&log_user=0&signature=a2f022c16517162df2dae431830e8dccb9b1b34a78ae9cbf971aeff76a65fc3f"
                                          data-title="PLS Solicitors" 
                                          data-subtitle="Promo Film"
                                          data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/pls-preview.jpg"
                                          data-desc=""
                                        />
                                        <img 
                                          onClick={videoModal}
                                          src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/solomon-preview-768x432.jpeg" 
                                          data-iframe="https://player.vimeo.com/progressive_redirect/playback/163800113/rendition/1080p/file.mp4?loc=external&log_user=0&signature=6a353695ec84279ba855460bef58978d66bef1eb880f06d3a51a7f9048d64838"
                                          data-title="Solomon"
                                          data-subtitle="Company Film"
                                          data-desc="Solomon Commercials are a nationwide manufacturer of temperature controlled vehicles. They supply a number of well known high street brands, such as Tesco, Sainsburys, John Lewis and many more. Solomon offer unrivalled customisation designing for their customers needs. They build bespoke tailor made solutions that meet their clients operational criteria. In 2012 we were commissioned to produce their first company film."
                                          data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/solomon-preview.jpeg"
                                        />
                                    </div>
                                    <a href="https://vimeo.com/showcase/5029373" target="__blank" className="underline mt-2 block">View more</a>
                                </div>
                              </div>
                            </motion.div>
                            )}
                          </AnimatePresence>
                      </div>
                      <div className={`form-checkbox ${checkboxValues1.includes("Trust") ? 'checked' : ''}`} data-checkbox="packages1">
                          <div className="checkbox-head flex flex-wrap tab:flex-nowrap">
                              <div className="left">
                                <h3 className="text-mobmd tab:text-md">Trust <span onClick={(e) => dropdownToggle('packages1')}><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"> <g id="Group_241" data-name="Group 241" transform="translate(-381 -667)"> <g id="Path_10" data-name="Path 10" transform="translate(381 667)" fill="none"> <path d="M7.5,0A7.5,7.5,0,1,1,0,7.5,7.5,7.5,0,0,1,7.5,0Z" stroke="none"/> <path d="M 7.5 1 C 3.915889739990234 1 1 3.915889739990234 1 7.5 C 1 11.08411026000977 3.915889739990234 14 7.5 14 C 11.08411026000977 14 14 11.08411026000977 14 7.5 C 14 3.915889739990234 11.08411026000977 1 7.5 1 M 7.5 0 C 11.64213943481445 0 15 3.35785961151123 15 7.5 C 15 11.64213943481445 11.64213943481445 15 7.5 15 C 3.35785961151123 15 0 11.64213943481445 0 7.5 C 0 3.35785961151123 3.35785961151123 0 7.5 0 Z" stroke="none" fill="#fff"/> </g> <path id="Path_20" data-name="Path 20" d="M1.19,4.19a.581.581,0,1,0,0-1.16.581.581,0,1,0,0,1.16ZM1.63,10V5.33H.76V10Z" transform="translate(387.305 667.986)" fill="#fff"/> </g> </svg></span></h3>
                                <p className="text-base opacity-50">Case Study Video</p>
                              </div>
                              <div className="middle">
                                <div className="inner">
                                  <p>A case study or client testimonial is as powerful a way to build client confidence as any - and capturing it on film has serious impact. It's one of the best ways to build 'Trust' with your audience, so this solution does exactly what it says in the name!</p>
                                  <span onClick={(e) => dropdownToggle('packages1')}>Find out more</span>
                                </div>
                              </div>
                              <div className="right flex">
                                <div className="price">
                                  <p className="text-mobmd tab:text-md"><span className="text-base opacity-50">From</span> £3,500</p>
                                </div>
                                <div className="checkbox">
                                    <label htmlFor="packages1" className="sr-only">Trust</label>
                                    <input type="checkbox" defaultChecked={checkboxValues1.includes("Trust") ? true : false} onChange={handleOnChange} name="packages" onClick={handleCheck} id="packages1" value="Trust" />
                                </div>
                              </div>
                          </div>
                          <AnimatePresence initial={false}>
                            {dropdown == 'packages1' && (
                            <motion.div
                              initial="collapsed"
                              animate="open"
                              exit="collapsed"
                              variants={{
                                open: { opacity: 1, height: "auto" },
                                collapsed: { opacity: 0, height: 0 }
                              }}
                              transition={{ duration: 0.8 }}
                              className="overflow-hidden"
                            >
                              <div className="checkbox-content">
                                <div className="checkbox-content__inner">
                                    <h4>What’s included?</h4>
                                    <ul>
                                      <li>Creative Development & Project Management</li>
                                      <li>Pre-Production</li>
                                      <li>1 Day Shoot - Camera Op</li>
                                      <li>2.5x Edit Days </li>
                                      <li>Library Music Track</li>
                                      <li>Asset Delivery</li>
                                    </ul>
                                    <h4>Example Films</h4>
                                    <div className="video-grid">
                                        <img
                                          onClick={videoModal}
                                          src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/purezza-preview-768x432.jpg" 
                                          data-iframe="https://player.vimeo.com/progressive_redirect/playback/351388311/rendition/1080p/file.mp4?loc=external&log_user=0&signature=086f021804e949873a684e1790f1005fd2ac837c2c931fbdc067d61e86782cb0"
                                          data-title="Purezza"
                                          data-subtitle="Mana Restaurant"
                                          data-desc="A premium film documenting why Mana Restaurant, in Ancoats, Manchester, see Purezza Water as the perfect fit for their needs and ethos."
                                          data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/purezza-preview.jpg"
                                        />
                                        <img
                                            onClick={videoModal}
                                            src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/harraby-preview-768x432.jpg" 
                                            data-iframe="https://player.vimeo.com/progressive_redirect/playback/198995512/rendition/1080p/file.mp4?loc=external&log_user=0&signature=42d2ecca7971d043280fd44175a485cb5a67856f08332fd6d87d0c86e36e3b6f"
                                            data-title="Atkins Global"
                                            data-subtitle="Harraby Case Study"
                                            data-desc="Atkins Global is one of the world's most respected design, engineering and project management consultancies. Driven by an unwavering attention to detail, they were looking to partner with a film production company to document a case study about the outstanding work they produce, and the effect it's creation has had on the local community. In this instance, the case study revolved around Harraby Community Campus, based in Carlisle."
                                            data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/harraby-preview.jpg"
                                        />
                                        <img
                                          onClick={videoModal}
                                          src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/innova-preview-768x432.jpg" 
                                          data-iframe="https://player.vimeo.com/progressive_redirect/playback/150889877/rendition/1080p/file.mp4?loc=external&log_user=0&signature=da4e837a935f2172b7a3b0ecc221e6727fa7c43f48f66458f32c6ade14ea0ca1"
                                          data-title="Innova Design Solutions"
                                          data-subtitle="Case Study"
                                          data-desc="Innova Design Solutions are a leading design, manufacture and supply company of furniture and interiors to the education, commercial and healthcare sectors. Having already been commissioned by Innova to produce some smaller case study films, we were then given a brief to follow the installation of a brand new laboratory at Manchester High School for Girls."
                                          data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/innova-preview.jpg"
                                        />
                                        <img
                                            onClick={videoModal}
                                            src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/gant-preview-768x432.jpg" 
                                            data-iframe="https://player.vimeo.com/progressive_redirect/playback/776975286/rendition/1080p/file.mp4?loc=external&log_user=0&signature=bb62c9ace4b3c60e9e8de8dc76b0a875e2f34547e7fff04913e85df6adb27b92"
                                            data-title="GANT"
                                            data-subtitle="Maris Case Study"
                                            data-desc=""
                                            data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/gant-preview.jpg"
                                        />
                                    </div>
                                    <a href="https://vimeo.com/showcase/standbycasestudies" target="__blank" className="underline mt-2 block">View more</a>
                                </div>
                              </div>
                            </motion.div>
                            )}
                          </AnimatePresence>
                      </div>

                      <div className={`form-checkbox ${checkboxValues1.includes("Recap") ? 'checked' : ''}`} data-checkbox="packages2">
                          <div className="checkbox-head flex flex-wrap tab:flex-nowrap">
                              <div className="left">
                                <h3 className="text-mobmd tab:text-md">Recap <span onClick={(e) => dropdownToggle('packages2')}><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"> <g id="Group_241" data-name="Group 241" transform="translate(-381 -667)"> <g id="Path_10" data-name="Path 10" transform="translate(381 667)" fill="none"> <path d="M7.5,0A7.5,7.5,0,1,1,0,7.5,7.5,7.5,0,0,1,7.5,0Z" stroke="none"/> <path d="M 7.5 1 C 3.915889739990234 1 1 3.915889739990234 1 7.5 C 1 11.08411026000977 3.915889739990234 14 7.5 14 C 11.08411026000977 14 14 11.08411026000977 14 7.5 C 14 3.915889739990234 11.08411026000977 1 7.5 1 M 7.5 0 C 11.64213943481445 0 15 3.35785961151123 15 7.5 C 15 11.64213943481445 11.64213943481445 15 7.5 15 C 3.35785961151123 15 0 11.64213943481445 0 7.5 C 0 3.35785961151123 3.35785961151123 0 7.5 0 Z" stroke="none" fill="#fff"/> </g> <path id="Path_20" data-name="Path 20" d="M1.19,4.19a.581.581,0,1,0,0-1.16.581.581,0,1,0,0,1.16ZM1.63,10V5.33H.76V10Z" transform="translate(387.305 667.986)" fill="#fff"/> </g> </svg></span></h3>
                                <p className="text-base opacity-50">Events Highlight Video</p>
                              </div>
                              <div className="middle">
                                <div className="inner">
                                  <p>An Events Highlights Video works on so many levels, both internally and externally. Internally it offers a chance for employees to feel valued and seen (on video potentially), whilst externally it shows the world how awesome you are. Events happen and people forget stuff, so giving them a timely 'Recap' post-event is the perfect way to hammer home those messages!</p>
                                  <span onClick={(e) => dropdownToggle('packages2')}>Find out more</span>
                                </div>
                              </div>
                              <div className="right flex">
                                <div className="price">
                                  <p className="text-mobmd tab:text-md"><span className="text-base opacity-50">From</span> £2,200</p>
                                </div>
                                <div className="checkbox">
                                    <label htmlFor="packages2" className="sr-only">Recap</label>
                                    <input type="checkbox" defaultChecked={checkboxValues1.includes("Recap") ? true : false} onChange={handleOnChange} name="packages" onClick={handleCheck} id="packages2" value="Recap" />
                                </div>
                              </div>
                          </div>
                          <AnimatePresence initial={false}>
                            {dropdown == 'packages2' && (
                            <motion.div
                              initial="collapsed"
                              animate="open"
                              exit="collapsed"
                              variants={{
                                open: { opacity: 1, height: "auto" },
                                collapsed: { opacity: 0, height: 0 }
                              }}
                              transition={{ duration: 0.8 }}
                              className="overflow-hidden"
                            >
                              <div className="checkbox-content">
                                <div className="checkbox-content__inner">
                                    <h4>What’s included?</h4>
                                    <ul>
                                      <li>Creative Development & Project Management</li>
                                      <li>Pre-Production</li>
                                      <li>1 Day Shoot - Producer & Camera Op</li>
                                      <li>2.5x Edit Days </li>
                                      <li>Library Music Track</li>
                                      <li>Asset Delivery</li>
                                    </ul>
                                    <h4>Example Films</h4>
                                    <div className="video-grid">
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/bbs-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/842532852/rendition/1080p/file.mp4?loc=external&log_user=0&signature=cbc26e96c4fe69e386c6288e402e607ca3fb2dfd41cb5c1f4b88e4854abaad1b"
                                        data-title="Better Business Summit"
                                        data-subtitle="Highlight Video"
                                        data-desc=""
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/bbs-preview.jpg"
                                        />
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/scala-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/255870812/rendition/1080p/file.mp4?loc=external&log_user=0&signature=3683011a7fdaafcbc507e2c5be5698eb86dfe9831f5f9fb499c384612048852d"
                                        data-title="Cake Solutions"
                                        data-subtitle="Berlin"
                                        data-desc="Cake Solutions exhibiting at Scala Days Berlin."
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/scala-preview.jpg"
                                        />
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/scala-copenhagen-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/255889330/rendition/1080p/file.mp4?loc=external&log_user=0&signature=8b93bf7656850ee151f7f991b6e7181923fb4667309b52f65f175a3a69700692"
                                        data-title="Scala Days"
                                        data-subtitle="Copenhagen"
                                        data-desc="Event Highlights film for Cake Solutions covering the Scala Days event in Copenhagen."
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/scala-copenhagen-preview.jpg"
                                        />
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/morsawrap-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/198976705/rendition/1080p/file.mp4?loc=external&log_user=0&signature=bccc6541be0e3329fe0078148982b75d1d8634a125ae7b9d3d39e4b19bb8c1b7"
                                        data-title="Morsawrap"
                                        data-subtitle="IMHX 2016"
                                        data-desc="Having previously worked with Jemac Packaging on their Morsawrap promotional film, they were looking for a promotional film that would highlight their eye-catching Morsawrap stand at IMHX 2016, at the NEC in Birmingham."
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/morsawrap-preview.jpg"
                                        />
                                        
                              
                                    </div>
                                    <a href="https://vimeo.com/showcase/eventfilming" target="__blank" className="underline mt-2 block">View more</a>
                                </div>
                              </div>
                            </motion.div>
                            )}
                          </AnimatePresence>
                      </div>

                      <div className={`form-checkbox ${checkboxValues1.includes("Hype") ? 'checked' : ''}`} data-checkbox="packages3">
                          <div className="checkbox-head flex flex-wrap tab:flex-nowrap">
                              <div className="left">
                                <h3 className="text-mobmd tab:text-md">Hype <span onClick={(e) => dropdownToggle('packages3')}><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"> <g id="Group_241" data-name="Group 241" transform="translate(-381 -667)"> <g id="Path_10" data-name="Path 10" transform="translate(381 667)" fill="none"> <path d="M7.5,0A7.5,7.5,0,1,1,0,7.5,7.5,7.5,0,0,1,7.5,0Z" stroke="none"/> <path d="M 7.5 1 C 3.915889739990234 1 1 3.915889739990234 1 7.5 C 1 11.08411026000977 3.915889739990234 14 7.5 14 C 11.08411026000977 14 14 11.08411026000977 14 7.5 C 14 3.915889739990234 11.08411026000977 1 7.5 1 M 7.5 0 C 11.64213943481445 0 15 3.35785961151123 15 7.5 C 15 11.64213943481445 11.64213943481445 15 7.5 15 C 3.35785961151123 15 0 11.64213943481445 0 7.5 C 0 3.35785961151123 3.35785961151123 0 7.5 0 Z" stroke="none" fill="#fff"/> </g> <path id="Path_20" data-name="Path 20" d="M1.19,4.19a.581.581,0,1,0,0-1.16.581.581,0,1,0,0,1.16ZM1.63,10V5.33H.76V10Z" transform="translate(387.305 667.986)" fill="#fff"/> </g> </svg></span></h3>
                                <p className="text-base opacity-50">Promotional Video</p>
                              </div>
                              <div className="middle">
                                <div className="inner">
                                  <p>Whether you're looking to advertise a brand or a product a promotional video is possibly the best medium to do it. It can be a brand awareness piece or it can be to showcase product features and even price. We make video content with a whole load of oomph and we want to create a 'Hype' around the subject, so let's get the people goin' and make it happen!</p>
                                  <span onClick={(e) => dropdownToggle('packages3')}>Find out more</span>
                                </div>
                              </div>
                              <div className="right flex">
                                <div className="price">
                                  <p className="text-mobmd tab:text-md"><span className="text-base opacity-50">From</span> £4,500</p>
                                </div>
                                <div className="checkbox">
                                    <label htmlFor="packages3" className="sr-only">Hype</label>
                                    <input type="checkbox" defaultChecked={checkboxValues1.includes("Hype") ? true : false} onChange={handleOnChange} name="packages" onClick={handleCheck} id="packages3" value="Hype" />
                                </div>
                              </div>
                          </div>
                          <AnimatePresence initial={false}>
                            {dropdown == 'packages3' && (
                            <motion.div
                              initial="collapsed"
                              animate="open"
                              exit="collapsed"
                              variants={{
                                open: { opacity: 1, height: "auto" },
                                collapsed: { opacity: 0, height: 0 }
                              }}
                              transition={{ duration: 0.8 }}
                              className="overflow-hidden"
                            >
                              <div className="checkbox-content">
                                <div className="checkbox-content__inner">
                                    <h4>What’s included?</h4>
                                    <ul>
                                      <li>Creative Development & Project Management</li>
                                      <li>Pre-Production</li>
                                      <li>1 Day Shoot - Producer/Director, Camera Op</li> 
                                      <li>4x Edit Days </li>
                                      <li>Library Music Track</li>
                                      <li>Asset Delivery</li>
                                    </ul>
                                    <h4>Example Films</h4>
                                    <div className="video-grid">
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/new-era-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/255933160/rendition/720p/file.mp4?loc=external&log_user=0&signature=6cff1f36e4f3cd4663d413c315f9ca23b84e7ee615afb118822c09b8306c1550"
                                        data-title="NEW ERA"
                                        data-subtitle="Manchester United"
                                        data-desc=""
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/new-era-preview.jpg"
                                        />
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/kakoa-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/795633231/rendition/1080p/file.mp4?loc=external&log_user=0&signature=a113a7144c8115bfae93c1304e0698514bd338e3fcf2e9b6e94b358040476731"
                                        data-title="Kakoa"
                                        data-subtitle="Luxury Plant Based Gifts"
                                        data-desc=""
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/kakoa-preview.jpg"
                                        />
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/uom-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/292739716/rendition/1080p/file.mp4?loc=external&log_user=0&signature=1abf2c1cd60b0fbb8780e42fa568ab5f7e3996b32ceb3c40243e6607b4fd3964"
                                        data-title="The University of Manchester"
                                        data-subtitle="Study Philosophy"
                                        data-desc=""
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/uom-preview.jpg"
                                        />
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/mcarthurglen-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/776984451/rendition/1080p/file.mp4?loc=external&log_user=0&signature=754145d808398b98951222079d48fe0748f932b2d92c115bad6f4c25c3e00e97"
                                        data-title="McArthurGlen"
                                        data-subtitle="Outlet Promo Film"
                                        data-desc="Here’s a stunning showcase of McArthurGlen’s York Designer Outlet; This is 1 out of 7 promotional films we produced for each of McArthurGlen’s sites. We also produced 30” versions for each site too, along with 16:9, 9:16, 4:5 inc. web banners too. We delivered 113 individual assets in total in the video editing production line of all production lines!!"
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/mcarthurglen-preview.jpg"
                                        />
                                    </div>
                                    <a href="https://vimeo.com/showcase/promofilms" target="__blank" className="underline mt-2 block">View more</a>
                                </div>
                              </div>
                            </motion.div>
                            )}
                          </AnimatePresence>
                      </div>

                      <div className={`form-checkbox ${checkboxValues1.includes("Trend") ? 'checked' : ''}`} data-checkbox="packages4">
                          <div className="checkbox-head flex flex-wrap tab:flex-nowrap">
                              <div className="left">
                                <h3 className="text-mobmd tab:text-md">Trend <span onClick={(e) => dropdownToggle('packages4')}><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"> <g id="Group_241" data-name="Group 241" transform="translate(-381 -667)"> <g id="Path_10" data-name="Path 10" transform="translate(381 667)" fill="none"> <path d="M7.5,0A7.5,7.5,0,1,1,0,7.5,7.5,7.5,0,0,1,7.5,0Z" stroke="none"/> <path d="M 7.5 1 C 3.915889739990234 1 1 3.915889739990234 1 7.5 C 1 11.08411026000977 3.915889739990234 14 7.5 14 C 11.08411026000977 14 14 11.08411026000977 14 7.5 C 14 3.915889739990234 11.08411026000977 1 7.5 1 M 7.5 0 C 11.64213943481445 0 15 3.35785961151123 15 7.5 C 15 11.64213943481445 11.64213943481445 15 7.5 15 C 3.35785961151123 15 0 11.64213943481445 0 7.5 C 0 3.35785961151123 3.35785961151123 0 7.5 0 Z" stroke="none" fill="#fff"/> </g> <path id="Path_20" data-name="Path 20" d="M1.19,4.19a.581.581,0,1,0,0-1.16.581.581,0,1,0,0,1.16ZM1.63,10V5.33H.76V10Z" transform="translate(387.305 667.986)" fill="#fff"/> </g> </svg></span></h3>
                                <p className="text-base opacity-50">Fashion Promo Video</p>
                              </div>
                              <div className="middle">
                                <div className="inner">
                                  <p>If you sell something that people wear, then a Fashion Promo Video is essential to bring it to life and inspire your customers. Highlighting the clothing features, quality and fit is a must, but also seeing someone look cool as f**k whilst wearing it at the same time makes it a no brainer to encourage a purchase. Video content in the fashion sector is a must, so let's collab to stay on 'Trend'.</p>
                                  <span onClick={(e) => dropdownToggle('packages4')}>Find out more</span>
                                </div>
                              </div>
                              <div className="right flex">
                                <div className="price">
                                  <p className="text-mobmd tab:text-md"><span className="text-base opacity-50">From</span> £5,500</p>
                                </div>
                                <div className="checkbox">
                                    <label htmlFor="packages4" className="sr-only">Trend</label>
                                    <input type="checkbox" defaultChecked={checkboxValues1.includes("Trend") ? true : false} onChange={handleOnChange} name="packages" onClick={handleCheck} id="packages4" value="Trend" />
                                </div>
                              </div>
                          </div>
                          <AnimatePresence initial={false}>
                            {dropdown == 'packages4' && (
                            <motion.div
                              initial="collapsed"
                              animate="open"
                              exit="collapsed"
                              variants={{
                                open: { opacity: 1, height: "auto" },
                                collapsed: { opacity: 0, height: 0 }
                              }}
                              transition={{ duration: 0.8 }}
                              className="overflow-hidden"
                            >
                              <div className="checkbox-content">
                                <div className="checkbox-content__inner">
                                    <h4>What’s included?</h4>
                                    <ul>
                                      <li>Creative Development & Project Management</li>
                                      <li>Pre-Production</li>
                                      <li>1 Day Shoot - Producer/Director, Camera Op, Makeup Artist, 1x Model </li>
                                      <li>4x Edit Days </li>
                                      <li>1x Day Studio Hire</li>
                                      <li>Library Music Track</li>
                                      <li>Asset Delivery</li>
                                    </ul>
                                    <h4>Example Films</h4>
                                    <div className="video-grid">
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/cotton-traders-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/789687638/rendition/1080p/file.mp4?loc=external&log_user=0&signature=209cbc61a3934166f874720b37429cc0510d3c3dd31dd98eec9d84ebc89f4440"
                                        data-title="Cotton Traders"
                                        data-subtitle="Will Mellor Collection"
                                        data-desc=""
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/cotton-traders-preview.jpg"
                                        />
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/new-era-2-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/293917526/rendition/1080p/file.mp4?loc=external&log_user=0&signature=b9241fc662f075e3dd3107854de900ba74168065f0bba9ec43bb14ad629374bd"
                                        data-title="New Era"
                                        data-subtitle="Tottenham Hotspur"
                                        data-desc=""
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/new-era-2-preview.jpg"
                                        />
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/cotton-traders-2-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/837989659/rendition/1080p/file.mp4?loc=external&log_user=0&signature=17d219d1cf80adf7b079b6cc7a998d82f18cce7aa3a974148d4ab52065860baa"
                                        data-title="Cotton Traders"
                                        data-subtitle="Colour"
                                        data-desc=""
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/cotton-traders-2-preview.jpg"
                                        />
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/jimbag-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/309455880/rendition/1080p/file.mp4?loc=external&log_user=0&signature=41db6e6923e5b572e74b358cfe2c72746707b7c62d9d7907f0e573bf98889427"
                                        data-title="Jim Bag"
                                        data-subtitle="Promo"
                                        data-desc=""
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/jimbag-preview.jpg"
                                        />
                                    </div>
                                    <a href="https://vimeo.com/showcase/standby-fashion" target="__blank" className="underline mt-2 block">View more</a>
                                </div>
                              </div>
                            </motion.div>
                            )}
                          </AnimatePresence>
                      </div>

                      <div className={`form-checkbox ${checkboxValues1.includes("Monthly") ? 'checked' : ''}`} data-checkbox="packages5">
                          <div className="checkbox-head flex flex-wrap tab:flex-nowrap">
                              <div className="left">
                                <h3 className="text-mobmd tab:text-md">Monthly <span onClick={(e) => dropdownToggle('packages5')}><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"> <g id="Group_241" data-name="Group 241" transform="translate(-381 -667)"> <g id="Path_10" data-name="Path 10" transform="translate(381 667)" fill="none"> <path d="M7.5,0A7.5,7.5,0,1,1,0,7.5,7.5,7.5,0,0,1,7.5,0Z" stroke="none"/> <path d="M 7.5 1 C 3.915889739990234 1 1 3.915889739990234 1 7.5 C 1 11.08411026000977 3.915889739990234 14 7.5 14 C 11.08411026000977 14 14 11.08411026000977 14 7.5 C 14 3.915889739990234 11.08411026000977 1 7.5 1 M 7.5 0 C 11.64213943481445 0 15 3.35785961151123 15 7.5 C 15 11.64213943481445 11.64213943481445 15 7.5 15 C 3.35785961151123 15 0 11.64213943481445 0 7.5 C 0 3.35785961151123 3.35785961151123 0 7.5 0 Z" stroke="none" fill="#fff"/> </g> <path id="Path_20" data-name="Path 20" d="M1.19,4.19a.581.581,0,1,0,0-1.16.581.581,0,1,0,0,1.16ZM1.63,10V5.33H.76V10Z" transform="translate(387.305 667.986)" fill="#fff"/> </g> </svg></span></h3>
                                <p className="text-base opacity-50"></p>
                              </div>
                              <div className="middle">
                                <div className="inner">
                                  <p>Become the 'King of Content' with Standby Social; it's the ultimate video production subscription. 12-months of quality content for a seriously good price. Delivering 2 days of production time every single month, with approximately 5x films or 2-minutes of content every month.</p>
                                  <span onClick={(e) => dropdownToggle('packages5')}>Find out more</span>
                                </div>
                              </div>
                              <div className="right flex">
                                <div className="price">
                                  <p className="text-mobmd tab:text-md">£950<span className="text-base opacity-50"> Per Month</span></p>
                                </div>
                                <div className="checkbox">
                                    <label htmlFor="packages5" className="sr-only">Monthly</label>
                                    <input type="checkbox" defaultChecked={checkboxValues1.includes("Monthly") ? true : false} onChange={handleOnChange} name="packages" onClick={handleCheck} id="packages5" value="Monthly" />
                                </div>
                              </div>
                          </div>
                          <AnimatePresence initial={false}>
                            {dropdown == 'packages5' && (
                            <motion.div
                              initial="collapsed"
                              animate="open"
                              exit="collapsed"
                              variants={{
                                open: { opacity: 1, height: "auto" },
                                collapsed: { opacity: 0, height: 0 }
                              }}
                              transition={{ duration: 0.8 }}
                              className="overflow-hidden"
                            >
                              <div className="checkbox-content">
                                <div className="checkbox-content__inner">
                                    <h4>What’s included?</h4>
                                    <ul>
                                    <li>12-month creative planning & project management</li>
                                      <li>Pre-Production</li>
                                      <li>4hr Shoot - Camera Op </li>
                                      <li>1.5x Edit Days </li>
                                      <li>Library Music Track</li>
                                      <li>Asset Delivery, in social formats</li>
                                    </ul>
                                    <h4>Example Films</h4>
                                    <div className="video-grid">
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/gymology-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/837993638/rendition/1080p/file.mp4?loc=external&log_user=0&signature=2fb0aa8061d1d3b1e9da312ac20751f3079ded668aa2d4a48e5ef6309fa6e797"
                                        data-title="Gymology"
                                        data-subtitle="Activewear"
                                        data-desc=""
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/gymology-preview.jpg"
                                        />
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/push-doctor-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/572525744/rendition/1080p/file.mp4?loc=external&log_user=0&signature=dc4ea50560aa99d840e3dde0fecf3cc2db4b473ce4d5a4499451007fb6853706"
                                        data-title="Push Doctor"
                                        data-subtitle="Explainer Video"
                                        data-desc=""
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/push-doctor-preview.jpg"
                                        />
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/velcro-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/572524890/rendition/1080p/file.mp4?loc=external&log_user=0&signature=9c24354a86bd014f89bf015ef66d00c6624ca2c3f323d775cb56763ac72f9318"
                                        data-title="Velcro"
                                        data-subtitle="Using Band Ties"
                                        data-desc=""
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/velcro-preview.jpg"
                                        />
                                        <img 
                                        onClick={videoModal}
                                        src="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/psychi-preview-768x432.jpg" 
                                        data-iframe="https://player.vimeo.com/progressive_redirect/playback/572525705/rendition/1080p/file.mp4?loc=external&log_user=0&signature=7cdafd6f002792bf86a7fd9171739366aa297864ac56b8b86d9530d3ffc97913"
                                        data-title="Psychi"
                                        data-subtitle="Orange Rope"
                                        data-desc=""
                                        data-placeholder="https://admin.standbyproductions.co.uk/wp-content/uploads/2023/07/psychi-preview.jpg"
                                        />
                                        
                                    </div>
                                    <a href="https://vimeo.com/showcase/10476695" target="__blank" className="underline mt-2 block">View more</a>
                                </div>
                              </div>
                            </motion.div>
                            )}
                          </AnimatePresence>
                      </div>

                    </fieldset>
                  </div>
                }


                {currentPage == 3 &&

                  <div className="form-modal__page form-modal__page3">
                    {renderFieldError('extras')}
                    <fieldset className="form-checkboxes form-checkboxes--cols">
                      <div className={`form-checkbox ${checkboxValues2.includes("Social Formats") ? 'checked' : ''}`} data-checkbox="extras0">
                          <div className="checkbox-head flex flex-wrap tab:flex-nowrap justify-between items-center">
                              <div className="left">
                                <h3 className="text-mobmd tab:text-md">Social Formats</h3>
                                <p className="text-base opacity-50">16:9, 1:1, 4:5, 9:16 ratios</p>
                                <p className="text-mobmd tab:text-md mt-3">£75</p>
                              </div>
                             
                              <div className="right flex">
                                <div className="checkbox">
                                    <label htmlFor="extras0" className="sr-only">Social Formats</label>
                                    <input type="checkbox" defaultChecked={checkboxValues2.includes("Social Formats") ? true : false} onChange={handleOnChange} name="extras" id="extras0"  onClick={handleCheck} value="Social Formats" />
                                </div>
                              </div>
                          </div>
                          
                      </div>

                      <div className={`form-checkbox ${checkboxValues2.includes("Shorter Social Edits") ? 'checked' : ''}`} data-checkbox="extras1">
                          <div className="checkbox-head flex flex-wrap tab:flex-nowrap justify-between items-center">
                              <div className="left">
                                <h3 className="text-mobmd tab:text-md">Shorter Social Edits</h3>
                                <p className="text-base opacity-50">30", 20", 6" second edits</p>
                                <p className="text-mobmd tab:text-md mt-3">£250</p>
                              </div>
                             
                              <div className="right flex">
                                <div className="checkbox">
                                    <label htmlFor="extras1" className="sr-only">Shorter Social Edits</label>
                                    <input type="checkbox" defaultChecked={checkboxValues2.includes("Shorter Social Edits") ? true : false} onChange={handleOnChange} name="extras" id="extras1"  onClick={handleCheck} value="Shorter Social Edits" />
                                </div>
                              </div>
                          </div>

                      </div>

                      <div className={`form-checkbox ${checkboxValues2.includes("Drone Filming") ? 'checked' : ''}`} data-checkbox="extras2">
                          <div className="checkbox-head flex flex-wrap tab:flex-nowrap justify-between items-center">
                              <div className="left">
                                <h3 className="text-mobmd tab:text-md">Drone Filming</h3>
                                <p className="text-base opacity-50">Simple aerial filming alongside video</p>
                                <p className="text-mobmd tab:text-md mt-3">£750</p>
                              </div>
                             
                              <div className="right flex">
                                <div className="checkbox">
                                    <label htmlFor="extras2" className="sr-only">Drone Filming</label>
                                    <input type="checkbox" defaultChecked={checkboxValues2.includes("Drone Filming") ? true : false} onChange={handleOnChange} name="extras" id="extras2"  onClick={handleCheck} value="Drone Filming" />
                                </div>
                              </div>
                          </div>

                      </div>

                      <div className={`form-checkbox ${checkboxValues2.includes("Photography") ? 'checked' : ''}`} data-checkbox="extras3">
                          <div className="checkbox-head flex flex-wrap tab:flex-nowrap justify-between items-center">
                              <div className="left">
                                <h3 className="text-mobmd tab:text-md">Photography</h3>
                                <p className="text-base opacity-50">Simple photography alongside video</p>
                                <p className="text-mobmd tab:text-md mt-3">£400</p>
                              </div>
                             
                              <div className="right flex">
                                <div className="checkbox">
                                    <label htmlFor="extras3" className="sr-only">Photography</label>
                                    <input type="checkbox" defaultChecked={checkboxValues2.includes("Photography") ? true : false} onChange={handleOnChange} name="extras" id="extras3" onClick={handleCheck} value="Photography" />
                                </div>
                              </div>
                          </div>
                          
                      </div>

                      <div className={`form-checkbox ${checkboxValues2.includes("Fast-Track Production") ? 'checked' : ''}`} data-checkbox="extras4">
                          <div className="checkbox-head flex flex-wrap tab:flex-nowrap justify-between items-center">
                              <div className="left">
                                <h3 className="text-mobmd tab:text-md">Fast-Track Production</h3>
                                <p className="text-base opacity-50">For tight deadline projects</p>
                                <p className="text-mobmd tab:text-md mt-3">£800</p>
                              </div>
                             
                              <div className="right flex">
                                <div className="checkbox">
                                    <label htmlFor="extras4" className="sr-only">Fast-Track Production</label>
                                    <input type="checkbox" defaultChecked={checkboxValues2.includes("Fast-Track Production") ? true : false} onChange={handleOnChange} name="extras" id="extras4" onClick={handleCheck} value="Fast-Track Production" />
                                </div>
                              </div>
                          </div>
                          
                      </div>

                      <div className={`form-checkbox ${checkboxValues2.includes("Behind The Scenes") ? 'checked' : ''}`} data-checkbox="extras5">
                          <div className="checkbox-head flex flex-wrap tab:flex-nowrap justify-between items-center">
                              <div className="left">
                                <h3 className="text-mobmd tab:text-md">Behind The Scenes</h3>
                                <p className="text-base opacity-50">Content creation from the shoot; 1x edited video and 20x stills</p>
                                <p className="text-mobmd tab:text-md mt-3">£1,200</p>
                              </div>
                             
                              <div className="right flex">
                                <div className="checkbox">
                                    <label htmlFor="extras5" className="sr-only">Behind The Scenes</label>
                                    <input type="checkbox" defaultChecked={checkboxValues2.includes("Behind The Scenes") ? true : false} onChange={handleOnChange} name="extras" id="extras5" onClick={handleCheck} value="Behind The Scenes" />
                                </div>
                              </div>
                          </div>
                         
                      </div>

                    </fieldset>
                  </div>

                }

                {/* {currentPage == 4 && 

                  <div className="form-modal__page form-modal__page4">

                    <div className="form-row text-black tab:flex w-100 justify-between">
                      <div className="form-field col-third relative">
                          <input
                            value={inputs.phone}
                            id="phone"
                            name="phone"
                            type="text"
                            placeholder=""
                            onChange={(e) => handleOnChange(e)}
                          />
                          <label htmlFor="phone" className="input-label">Phone (Optional)</label>
                          {renderFieldError('phone')}
                      </div>

                      <div className="form-field col-third relative">
                          <input
                            value={inputs.company}
                            id="company"
                            name="company"
                            type="text"
                            placeholder=""
                            onChange={(e) => handleOnChange(e)}
                          />
                          <label htmlFor="company" className="input-label">Company</label>
                          {renderFieldError('company')}
                      </div>

                      <div className="form-field col-third relative">
                          <input
                            value={inputs.budget}
                            id="budget"
                            name="budget"
                            type="text"
                            placeholder=""
                            onChange={(e) => handleOnChange(e)}
                          />
                          <label htmlFor="budget" className="input-label">Budget (Optional)</label>
                          {renderFieldError('budget')}
                      </div>

                    </div>
                    <div className="form-row text-black tab:flex w-100 justify-between">

                      <div className="form-field col-full relative">
                          <textarea
                            value={inputs.additionalInfo}
                            name="additionalInfo"
                            id="additionalInfo"
                            placeholder=""
                            onChange={(e) => handleOnChange(e)}
                          ></textarea>
                          <label htmlFor="additionalInfo" className="input-label">Tell us more about the video content you’re hoping to produce</label>
                          {renderFieldError('additionalInfo')}
                      </div>
                    </div>

                   

                </div>
                
                } */}
                                
              </div>

              <div className="form-modal__top">
                <div className="container flex justify-between items-start">
                {currentPage < 4 && 
                <div className="form-modal__intro">
                    <div className="page-number text-md">
                      0{currentPage}/0{maxPages}
                    </div>
                </div>
                }
                <div className="form-modal__nav flex">
                    {(currentPage > 1 && currentPage < 4) && 
                      <button type="button" className={`form-nav-arrow page-${currentPage}`} onClick={() => setCurrentPage(currentPage - 1)} aria-label="Previous">
                         Back
                      </button>
                    }

                    {(currentPage == 1 || currentPage == 4) && 
                      <button type="button" className="form-nav-arrow" onClick={closeModal} aria-label="Close">
                         Close
                      </button>
                    }

                    {currentPage < maxPages && 
                      <button type="button" className="form-nav-arrow primary" onClick={() => nextPage()} aria-label="Next">
                         Next
                      </button>
                    }

                    {currentPage == maxPages && 
                      <button type="button" aria-label="Submit" className="primary" onClick={() => setSubmissionClick(true)}>
                          Get Your Quote
                      </button>
                    }
                </div>
                </div>
              </div>
 
              

            </form>
            }

            {(currentPage == 4 && content.image2?.localFile?.childImageSharp) &&

              <div className="form-modal__page form-modal__page5 quote">

                <div className="container">

                  <h2 className="quote__title w-100 tab:w-full xwide:w-9/12">Here’s your final quote. We’ll be in touch</h2>
                  <div className="quote__outer tab:flex justify-between w-100 pt-16">

                  <div className="quote__inner tab:flex justify-between tab:w-full note:w-7/12">
                    <div className="quote__packages mb-6 tab:mb-0">
                      <p className="text-base opacity-50 mb-4">Packages</p>
                      {checkboxValues1.map((item, idx) => { return (
                        <div className="flex quote-item items-end mb-4" key={idx}>
                          <p className="text-base sml:text-md med:text-mobmd tab:text-md">{item}</p>
                          <p className="text-base opacity-50 sml:pb-1 pl-3">{ findPrice(item, priceList1) }</p>
                        </div>
                      )})}
                    </div>
                    <div className="quote__extras mb-6 tab:mb-0">
                      <p className="text-base opacity-50 mb-4">Extras</p>
                      {checkboxValues2.map((item, idx) => { return (
                        <div className="flex quote-item items-end mb-4" key={idx}>
                          <p className="text-base sml:text-md med:text-mobmd tab:text-md">{item}</p>
                          <p className="text-base opacity-50 sml:pb-1 pl-3">{ findPrice(item, priceList2) }</p>
                        </div>
                      )})}
                    </div>
                    <div className="quote__total">
                      <p className="text-base opacity-100 mb-4">Total</p>
                      <div className="quote-item items-end">
                        <p className="text-base sml:text-md med:text-mobmd tab:text-md">
                          {totalPrice}
                        </p>
                      </div>
                    </div>
                  </div>

                </div>

                <div className="quote__contact-details pb-16">

                  <p className="mb-12">{serverState.status?.msg}</p>

                  <p className="mb-5"><strong>Get in touch with us if you want to talk to us now</strong></p>
                  <p className="mb-0">
                    <a
                      href={`tel: ${wp.globalOptions.globalSiteOptions?.phoneNumber}`}
                    >
                      {wp.globalOptions.globalSiteOptions?.phoneNumber}
                    </a>
                  </p>
                  <p className="mb-0">
                    <a href={`mailto: ${wp.globalOptions.globalSiteOptions?.email}`}>
                    {wp.globalOptions.globalSiteOptions?.email}
                    </a>
                  </p>
                

                </div>

              </div>

              <GatsbyImage 
                  image={getImage(content.image2.localFile.childImageSharp)} 
                  className="hidden tab:block tab:w-4/12 xwide:w-5/12 confirmation_image" 
                  alt={content.image2.altText} 
                  loading="eager"
                  layout="fullWidth"
              />   

              <button type="button" className="form-nav-arrow" onClick={closeModalAndReset} aria-label="Close">
                  <svg xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 53 53">
                    <g id="Group_23" data-name="Group 23" transform="translate(-295 -844)">
                      <g id="Ellipse_6" data-name="Ellipse 6" transform="translate(348 897) rotate(180)" fill="none" stroke="#fff" strokeWidth="1">
                        <circle cx="26.5" cy="26.5" r="26.5" stroke="none"/>
                        <circle cx="26.5" cy="26.5" r="26" fill="none"/>
                      </g>
                      <g id="Group_242" data-name="Group 242" transform="translate(-4.5 0.002)">
                        <path id="Path_7" data-name="Path 7" d="M816.855-21774.391l11.033,11.033-11.033,11.031" transform="translate(1153.872 -20892.859) rotate(180)" fill="none" stroke="#fff" strokeWidth="1"/>
                        <path id="Path_21" data-name="Path 21" d="M816.855-21774.391l11.033,11.033-11.033,11.031" transform="translate(-501.872 22633.857)" fill="none" stroke="#fff" strokeWidth="1"/>
                      </g>
                    </g>
                  </svg>
              </button>

            </div>
                        


            }


        </motion.div>
      }
      </AnimatePresence>
      </TransitionPortal>

    
    </>
  )
}

export default ContactForm2022
